import React from 'react';
import {Avatar, Badge, Button, Card, Col, Space, Tag, Typography} from 'antd';

import {CalendarOutlined, UserOutlined,} from '@ant-design/icons';
import toFaNumber, {toFaNumberFormat} from "@/lib/utils/number";

import {GeneratedImage} from "@/pages/student/lessons/take/_section/GenerateLessonImage";
import {useNavigate} from "react-router-dom";
import {URLS} from "@/lib/urls";
import {sprintf} from "@/lib/utils/sprintf";
import RenderIf from "@/components/render-if";


const {Title, Text} = Typography;

const {Meta} = Card;


export const lessonGenderNames = {
    'male': 'آقا',
    'female': 'خانم',
    'all': 'آقا / خانم'
};
export const teacherGenderNames = {
    'male': 'آقای',
    'female': 'خانم',
    '': 'استاد'
};
// Helper functions
export const weekdayNames = {
    'saturday': 'شنبه',
    'sunday': 'یکشنبه',
    'monday': 'دوشنبه',
    'tuesday': 'سه‌شنبه',
    'wednesday': 'چهارشنبه',
    'thursday': 'پنج‌شنبه',
    'friday': 'جمعه'
};

export default function LessonCard({classItem, onClick}) {
    const navigate = useNavigate();

    const weekOrder = {
        saturday: 0,
        sunday: 1,
        monday: 2,
        tuesday: 3,
        wednesday: 4,
        thursday: 5,
        friday: 6,
    };

    const formatSchedule = (times) => {
        return [...times]
            .sort((a, b) => weekOrder[a.weekday] - weekOrder[b.weekday])
            .map(
                (time) =>
                    `${weekdayNames[time.weekday]} ${toFaNumber(time.start)} تا ${toFaNumber(time.end)}`
            )
            .join(" | ");
    };

    const lessonDetailElement = (<Card
        className={'w-[100%]'}
        hoverable
        cover={
            <GeneratedImage title={toFaNumber(classItem?.topic?.title)}/>
        }
        actions={[
            <Button type="primary" size="large" className={'m-1 block w-[98%]'}
                    onClick={() => {
                        navigate(sprintf(URLS.student.lessons.takeLesson, {id: classItem.id}))
                    }

                    }>
                مشاهده جزئیات
            </Button>
        ]}
    >
        <Meta
            title={
                <div>
                    <Title level={5} className={''}>
                        <div className={'text-wrap'}>
                            {toFaNumber(classItem?.topic?.title)}
                        </div>
                    </Title>
                    <Space size="small" className={'flex flex-wrap'}>
                        <Tag className={'text-wrap'} color="green">{lessonGenderNames[classItem?.gender]}</Tag>
                        <Tag className={'text-wrap'} color="blue">{toFaNumber(classItem?.topic?.group?.title)}</Tag>
                        <Tag className={'text-wrap'} color="pink">{toFaNumber(classItem?.topic?.grade?.title)}</Tag>
                        <Tag className={'text-wrap'} color="gold">{toFaNumber(classItem?.topic?.course?.title)}</Tag>

                    </Space>
                </div>
            }
            description={
                <div>
                    <Text type="secondary">
                        <div className={'mb-4'}>

                            {toFaNumber(classItem?.title)}
                        </div>
                    </Text>

                    <Space direction="vertical" size="small"
                           style={{width: '100%'}}>
                        <RenderIf condition={classItem?.teacher}>
                            <Space>
                                <Avatar src={classItem?.teacher_detail?.avatar} size="small" icon={<UserOutlined/>}/>
                                <Text>{teacherGenderNames[classItem?.teacher_detail?.gender]} {' '}
                                    {toFaNumber(classItem?.teacher_detail?.firstname)} {toFaNumber(classItem?.teacher_detail?.lastname)}</Text>
                            </Space>
                        </RenderIf>

                        {classItem?.times && classItem?.times.length > 0 && (
                            <Space>
                                <CalendarOutlined/>
                                <Text style={{fontSize: '12px'}}>
                                    {formatSchedule(classItem?.times)}
                                </Text>
                            </Space>
                        )}


                        <Space>
                            <UserOutlined/>
                            <Text> <span
                                className={' '}>ظرفیت باقیمانده: </span>{toFaNumberFormat(classItem?.capacity ?? 0)} نفر
                            </Text>
                            {/*<small> ( <b>{toFaNumberFormat(classItem?.count ?? 0)}</b> نفر ثبت‌نام کرده*/}
                            {/*    از {toFaNumberFormat(classItem?.maxperson ?? 0)} )</small>*/}

                        </Space>


                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '12px'
                        }}>
                            <Space>
                                <Tag
                                    color="purple">کد: {toFaNumber(classItem?.code)}</Tag>
                            </Space>
                            {classItem?.price > 0 &&
                                <Title level={4} style={{margin: 0, color: '#1890ff'}}>
                                    {toFaNumberFormat(classItem?.price)} تومان
                                </Title>}

                        </div>
                    </Space>
                </div>
            }
        />
    </Card>)

    return (<Col xs={30} sm={12} lg={8} key={classItem?.id} className={'w-full'} onClick={onClick}>

        <RenderIf condition={classItem?.price === 0} falsyElement={<>
            <RenderIf condition={classItem?.installment} falsyElement={lessonDetailElement}>
                <Badge.Ribbon text="پرداخت اقساطی" color="blue">
                    {lessonDetailElement}
                </Badge.Ribbon>
            </RenderIf>
        </>}>

            <Badge.Ribbon text="رایگان" color="green">
                {lessonDetailElement}
            </Badge.Ribbon>
        </RenderIf>

    </Col>)
}